module.exports = __webpack_public_path__ + "img/67.cef65bef.jpg";